import React from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from "../context/GlobalContext";


export const Menu = () => {
	const { setMenuOpen, setChild, setNested } = useGlobalContext()

	function menuToggle() {
		setMenuOpen(false);
		setChild('');
		setNested(false)

		document.body.classList.remove('menu-open');
	}


	return (
		<React.Fragment>
			<div id="menuDiv" className="l-menu">
				<div className="l-menu__menu-wrap l-container">
					<Link className="l-menu__link" to={{ pathname: "home" }}
						onClick={() => menuToggle()}>
						<div className="l-menu__link-icon" />
						<div className="l-menu__link-title">
							HOME
								</div>
					</Link>
					<Link className="l-menu__link" to={{ pathname: "bio" }}
						onClick={() => menuToggle()}>
						<div className="l-menu__link-icon" />
						<div className="l-menu__link-title">
							BIO
								</div>
					</Link>
					<Link className="l-menu__link" to={{ pathname: "web_development" }}
						onClick={() => menuToggle()}>
						<div className="l-menu__link-icon" />
						<div className="l-menu__link-title">
							WEB DEVELOPMENT
								</div>
					</Link>
					<Link className="l-menu__link" to={{ pathname: "video" }}
						onClick={() => menuToggle()}>
						<div className="l-menu__link-icon" />
						<div className="l-menu__link-title">
							VIDEO
								</div>
					</Link>
					<Link className="l-menu__link" to={{ pathname: "graphic_design" }}
						onClick={() => menuToggle()}>
						<div className="l-menu__link-icon" />
						<div className="l-menu__link-title">
							GRAPHIC DESIGN
								</div>
					</Link>
				</div>
			</div>
		</React.Fragment>

	)
}
